<div class="notification-container">
  <!-- Logo Section -->
  <div class="logo-section">
    <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
  </div>

  <div class="notification-card">
    <!-- Header Section -->
    <div class="header-section">
      <div class="icon-section">
        <mat-icon class="success-icon">mark_email_read</mat-icon>
      </div>
      <h1 class="notification-title">Check Your Email</h1>
      <p class="notification-subtitle">If an account exists with this email, a password reset link has been sent.</p>
    </div>

    <!-- Action Button -->
    <button
      class="submit-button full-width"
      mat-raised-button
      color="primary"
      (click)="onNavigateToSignIn()"
    >
      <mat-icon>arrow_back</mat-icon>
      Back to Sign In
    </button>
  </div>
</div>